<form class="w-100 d-flex justify-content-end align-items-center" [formGroup]="searchForm" (submit)="onSubmitSearch()">
  <label for="search" hidden> Cerca nel portale </label>
  <input type="text" aria-label="Cerca nel portale" formControlName="searchText"
    class="form-control search-input position-relative" name="search" id="search" placeholder="Cerca nel portale" />
  <button type="submit" class="btn btn-sm bg-transparent position-absolute pe-2" [disabled]="searchForm.invalid">
    <i class="fas fa-search"></i>
  </button>
</form>


<iframe id="iframe-scan" style="display: none;"></iframe>
<div *ngIf="itemsFound.length > 0">
  <h3>Risultati della ricerca:</h3>
  <ul>
    <li *ngFor="let item of itemsFound">
      <a [href]="item.url" target="_blank">
        <strong>{{ item.title }}</strong>
      </a>
      - Occorrenze: {{ item.occurrences }}
    </li>
  </ul>
</div>